export default function isValidNumber(number) {
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(number);
}
